import { templates }          from "./templates";
import { CustomerConfig }     from "../../src/types";
import { renderTemplate }     from "./render";

const config: CustomerConfig = {
    name: {
        en: 'Image card Generator Demo',
        de: 'Bildkarten Generator Demo'
    },
    title: {
        en: 'Image card Generator Demo',
        de: 'Bildkarten Generator Demo'
    },
    favicon: require('./assets/favicon.png').default,
    logo: {
        path: require('./assets/alchemisten-logo-big.svg').default,
        smallPath: require('./assets/favicon.png').default,
        width: 230,
        height: 56,
        margin: 20
    },
    tracking: {
        gaCode: 'G-R3QS9XWFDL'
    },
    /*
    info: {
        en: 'defaultTranslation',
        de: 'defaultTranslation'
    },
     */
    templates,
    fonts: [
        {
            name: 'Poppins-Regular',
            src: `url(${ require('./assets/fonts/Poppins-Regular.ttf').default })`
        },
        {
            name: 'Poppins-SemiBold',
            src: `url(${ require('./assets/fonts/Poppins-SemiBold.ttf').default })`
        },
        {
            name: 'AlFresco',
            src: `url(${ require('./assets/fonts/AlFresco.ttf').default })`
        },
        {
            name: 'Parisienne-Regular',
            src: `url(${ require('./assets/fonts/Parisienne-Regular.ttf').default })`
        },
        {
            name: 'Roboto-Light',
            src: `url(${ require('./assets/fonts/Roboto-Light.ttf').default })`
        },
        {
            name: 'MeieScript-Regular',
            src: `url(${ require('./assets/fonts/MeieScript-Regular.ttf').default })`
        },
        {
            name: 'Cookie-Regular',
            src: `url(${ require('./assets/fonts/Cookie-Regular.ttf').default })`
        },
        {
            name: 'Tangerine-Bold',
            src: `url(${ require('./assets/fonts/Tangerine-Bold.ttf').default })`
        }
    ],
    theme: {
        palette: {
            common: { black: "#000", white: "#fff" },
            background: { paper: "#fff", default: "#fafafa" },
            primary: {
                light: "rgba(84, 89, 95, 1)",
                main: "rgba(17, 17, 17, 1)",
                dark: "rgba(0, 0, 0, 1)",
                contrastText: "#fff"
            },
            secondary: {
                light: "rgba(0, 143, 100, 1)",
                main: "rgba(0, 157, 159, 1)",
                dark: "rgba(0, 137, 192, 1)",
                contrastText: "#fff"
            },
            error: { light: "#e57373", main: "#f44336", dark: "#d32f2f", contrastText: "#fff" },
            text: {
                primary: "rgba(0, 0, 0, 0.87)",
                secondary: "rgba(0, 0, 0, 0.54)",
                disabled: "rgba(0, 0, 0, 0.38)",
                hint: "rgba(0, 0, 0, 0.38)"
            }
        }
    },
    renderTemplate
}

export default config;